// export const CREDITS = {
//   name: "Rishav Chanda",
//   github: "https://github.com/rishavchanda",
// }
export const Bio = {
  name: 'Raghuvansh Mani Tiwari',
  roles: ['Javascript', 'Angular', 'React'],
  description:
    'Innovative Frontend Developer with over 3 years of expertise in crafting dynamic and intuitive user interfaces. Proven proficiency in JavaScript, TypeScript, and leading frontend frameworks like Angular and React.',
  location: 'Indore, Madhya Pradesh, India',
  email: 'tiwari1998@hotmail.com',
  phone: '+917000668675',
  linkedin: 'https://www.linkedin.com/in/vansh-tiwari',
  resume: 'https://drive.google.com/file/d/1-gWxKyWt40JiZ_MQIJZr-X-QotbNBdxG/view',
  github: 'https://github.com/vansh-tiwari',
}

export const skills = [
  {
    title: 'Frontend',
    skills: [
      {
        name: 'JavaScript',
        image:
          'https://img.shields.io/badge/JavaScript-F7DF1E?logo=javascript&logoColor=black&style=for-the-badge',
      },
      {
        name: 'TypeScript',
        image:
          'https://img.shields.io/badge/TypeScript-3178C6?logo=typescript&logoColor=white&style=for-the-badge',
      },
      {
        name: 'React',
        image:
          'https://img.shields.io/badge/React-61DAFB?logo=react&logoColor=black&style=for-the-badge',
      },
      {
        name: 'Angular',
        image:
          'https://img.shields.io/badge/Angular-DD0031?logo=angular&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Electron',
        image:
          'https://img.shields.io/badge/Electron-47848F?logo=electron&logoColor=white&style=for-the-badge',
      },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Node.js',
        image:
          'https://img.shields.io/badge/Node.js-339933?logo=nodedotjs&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Python',
        image:
          'https://img.shields.io/badge/Python-3776AB?logo=python&logoColor=white&style=for-the-badge',
      },
      {
        name: 'PostgreSQL',
        image:
          'https://www.zdnet.com/a/img/resize/e7aff3398e12f0fa70fd66238d743054c4c8b95e/2018/04/19/092cbf81-acac-4f3a-91a1-5a26abc1721f/postgresql-logo.png?auto=webp&fit=crop&height=900&width=1200',
      },
      {
        name: 'Flask',
        image:
          'https://img.shields.io/badge/Flask-000000?logo=flask&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Express',
        image:
          'https://img.shields.io/badge/Express-000000?logo=express&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Firebase',
        image:
          'https://img.shields.io/badge/Firebase-FFCA28?logo=firebase&logoColor=black&style=for-the-badge',
      },
      {
        name: 'MySQL',
        image:
          'https://img.shields.io/badge/MySQL-4479A1?logo=mysql&logoColor=white&style=for-the-badge',
      },
    ],
  },
  {
    title: 'Libraries',
    skills: [
      {
        name: 'NgRx',
        image: 'https://ngrx.io/assets/images/badge.svg',
      },
      {
        name: 'RxJS',
        image: 'https://rxjs.dev/generated/images/marketing/home/Rx_Logo-512-512.png',
      },
      {
        name: 'MUI',
        image:
          'https://img.shields.io/badge/MUI-007FFF?logo=mui&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Angular Material',
        image:
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZVgZWIcPNwLS5teVwRpcYqpbnNjUx-WRvtKH4fHdf&s',
      },
      {
        name: 'Redux',
        image:
          'https://img.shields.io/badge/Redux-764ABC?logo=redux&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Bootstrap',
        image:
          'https://img.shields.io/badge/Bootstrap-7952B3?logo=bootstrap&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Tailwind CSS',
        image:
          'https://img.shields.io/badge/Tailwind CSS-06B6D4?logo=tailwindcss&logoColor=black&style=for-the-badge',
      },
      {
        name: 'MUI',
        image:
          'https://img.shields.io/badge/MUI-007FFF?logo=mui&logoColor=white&style=for-the-badge',
      },
    ],
  },
  {
    title: 'Miscellaneous',
    skills: [
      {
        name: 'Linux',
        image:
          'https://img.shields.io/badge/Linux-FCC624?logo=linux&logoColor=black&style=for-the-badge',
      },
      {
        name: 'MEAN',
        image: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Meanstack-624x250.jpg',
      },
      {
        name: 'MERN',
        image: 'https://upload.wikimedia.org/wikipedia/commons/9/94/MERN-logo.png',
      },
      {
        name: 'Git',
        image:
          'https://img.shields.io/badge/Git-F05032?logo=git&logoColor=white&style=for-the-badge',
      },
      {
        name: 'GitHub',
        image:
          'https://img.shields.io/badge/GitHub-181717?logo=github&logoColor=white&style=for-the-badge',
      },
      {
        name: 'GitLab',
        image:
          'https://img.shields.io/badge/GitLab-FC6D26?logo=gitlab&logoColor=black&style=for-the-badge',
      },
      {
        name: 'Jira',
        image:
          'https://img.shields.io/badge/Jira-0052CC?logo=jira&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Trello',
        image:
          'https://img.shields.io/badge/Trello-0052CC?logo=trello&logoColor=white&style=for-the-badge',
      },
      {
        name: 'OpenCV',
        image:
          'https://img.shields.io/badge/OpenCV-5C3EE8?logo=opencv&logoColor=white&style=for-the-badge',
      },
      {
        name: 'Webpack',
        image:
          'https://img.shields.io/badge/Webpack-8DD6F9?logo=webpack&logoColor=black&style=for-the-badge',
      },
    ],
  },
]

export const experiences = [
  {
    id: 1,
    img: 'https://media.licdn.com/dms/image/C4D0BAQHJ35wA9TN2kA/company-logo_200_200/0/1660626981352?e=1718841600&v=beta&t=naIHjt7_COged3zblPj9h7bUUs3AKPjSKtAWTBdTEkg',
    role: 'Senior Software Engineer',
    company: 'Metafic',
    date: 'January 2024 - March 2024',
    desc: 'Innovated by adding dynamic keyword highlighting in PDFs and WhatsApp-style chat media attachments. Created an HR development project to find suitable candidates based on skills.',
    skills: ['ReactJs', 'Redux', 'Material UI', 'JavaScript'],
    doc: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-06.png?alt=media&token=97933bb5-37d2-4774-8318-786d869e7287',
  },
  {
    id: 2,
    img: 'https://media.licdn.com/dms/image/C4D0BAQHJ35wA9TN2kA/company-logo_200_200/0/1660626981352?e=1718841600&v=beta&t=naIHjt7_COged3zblPj9h7bUUs3AKPjSKtAWTBdTEkg',
    role: 'Software Engineer',
    company: 'Metafic',
    date: 'December 2022 - January 2024',
    desc: 'Engaged in React with Typescript development, proficiently crafting both class-based and functional components. Created reusable building blocks that reduced development time by 20%. Developed payment features using Formik and Material-UI. Expertise in designing and implementing RESTful APIs using industry-standard protocols and best practices.',
    skills: ['ReactJs', 'Redux', 'Angular', 'Jest-Cucumber', 'Material UI', 'JavaScript'],
    doc: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-40-17.png?alt=media&token=5051faa4-a531-4bca-a045-8c65715e7a0e',
  },
  {
    id: 3,
    img: 'https://media.licdn.com/dms/image/C4E0BAQFaUPWC36XgXw/company-logo_200_200/0/1630624337261/gammastack_logo?e=1718841600&v=beta&t=YSY3IY08A6n5uS9PStNWBA5Y3pBexEKkYL62NEc3TQQ',
    role: 'Solution Engineer',
    company: 'Gammastack',
    date: 'February 2021 - December 2022',
    desc: 'Contributed to a Fin-Tech project for OPENPAYD (Bulgaria), demonstrating expertise in RESTful web services, code review, and code refactoring. Proficiently worked with Angular (v8-14), SCSS, MUI, TypeScript and created responsive designs for mobile and tablet interfaces. Utilized a customized NgRx store and developed end-to-end Cypress tests. Implemented the ”Split Your Work to Smallest Bits” (SYW) policy in a Single Page Application (SPA) context',
    skills: ['AngularJs', 'ReactJs', 'Redux', 'NodeJs', 'Material UI', 'Cypress', 'JavaScript'],
    doc: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-41-37.png?alt=media&token=0a72839f-f4e4-4dab-b76d-ab8fc20ac8d9',
  },
]

export const education = [
  {
    id: 1,
    img: 'https://upload.wikimedia.org/wikipedia/en/a/ae/Devi_Ahilya_Vishwavidyalaya_Logo.png',
    school: 'Institute of Engineering and Technology, DAVV, Indore',
    passed: '2021',
    desc: 'I completed my Bachelor of Engineering in Information Technology from the Institute of Engineering and Technology, DAVV, Indore in 2021.',
    degree: 'Bachelor of Engineering - BE, Information Technology',
  },
]

export const projects = [
  {
    id: 0,
    title: 'Portfolio',
    date: 'Mar 2024',
    description: 'Made a portfolio by taking idea from existing portfolios in Internet',
    image: 'https://iili.io/Jjht1u2.png',
    tags: ['React', 'Animation', 'MUI'],
    category: 'web app',
    github: 'https://github.com/vansh-tiwari/vansh-tiwari.github.io',
    webapp: 'https://vansh-tiwari.github.io',
  },
  {
    id: 1,
    title: 'Basic Pizza Shop',
    date: 'Mar 2024',
    description: "Made a pizza shop with it's functionalities",
    image: 'https://iili.io/JjhtvwB.png',
    tags: ['React', 'Redux', 'CSS'],
    category: 'web app',
    github: 'https://github.com/vansh-tiwari/pizza-shop',
    webapp: 'https://vqgq4h-3000.csb.app/',
  },
  {
    id: 2,
    title: 'Codechef Classroom',
    date: 'Jan 2021',
    description:
      'Created a prototype where teachers use question code for assignments and students solve them on the CodeChef website.',
    image: 'https://iili.io/JXRnrdX.jpg',
    tags: ['Node', 'Express', 'Firebase', 'Bootstrap', 'HTML'],
    category: 'web app',
    github: '',
    webapp: '',
  },
  {
    id: 3,
    title: 'Trashtalk',
    date: 'May 2020',
    description:
      'Created a web app that fetches Codechef user information using the web-scraping technique to compare them.',
    image: 'https://iili.io/JXRxURn.md.png',
    tags: ['Python', 'flask', 'beautifulsoup', 'CSS', 'Javascript'],
    category: 'web app',
    github: 'https://github.com/vansh-tiwari/trashtalk',
    webapp: '',
  },
  {
    id: 4,
    title: 'Animozi',
    date: 'Jan 2018',
    description:
      '36-hour-long Hackathon. Programmed a script to extract face information from the camera and crafted an emoji around it',
    image: 'https://iili.io/JXR5XdQ.png',
    tags: ['Python', 'opencv', 'pandas'],
    category: 'desktop app',
    github: 'https://drive.google.com/file/d/17GqLDBmUt1gMCUqXEo7V4acDroN4s_Fj/view',
    webapp: '',
  },
]
